import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "staff-page embed-page" }

import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import PropertyDetailContent from '@/components/PropertyDetailContent.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PropertyDetailEmbed',
  setup(__props) {

const route = useRoute();
const propertyId = ref<number | null>(null);
const highlightedContactId = ref<number | null>(null);

onMounted(() => {
  const id = route.params.id;
  if (id) {
    propertyId.value = Number(id);
  }

  const contactIdParam = route.query.contactId;
  if (contactIdParam) {
    highlightedContactId.value = parseInt(contactIdParam as string, 10);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (propertyId.value)
      ? (_openBlock(), _createBlock(PropertyDetailContent, {
          key: 0,
          "property-id": propertyId.value,
          "highlighted-contact-id": highlightedContactId.value
        }, null, 8, ["property-id", "highlighted-contact-id"]))
      : _createCommentVNode("", true)
  ]))
}
}

})